import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const KEY = "ss.settings.open";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; } };

/** Collapsible settings section. Children mount only while open, so heavy panels (QuickBooks, storage) don't fetch until needed. */
export function SettingsSection({ id, icon: Icon, title, description, badge, defaultOpen = false, children }) {
  const [open, setOpen] = useState(() => { const v = read()[id]; return v == null ? defaultOpen : v; });
  const toggle = () => { const n = !open; setOpen(n); try { localStorage.setItem(KEY, JSON.stringify({ ...read(), [id]: n })); } catch { /* ignore */ } };
  return (
    <section className={`rounded-lg border bg-white transition-colors ${open ? "border-slate-300 shadow-sm" : "border-slate-200 hover:border-slate-300"}`} data-testid={`settings-section-${id}`}>
      <button type="button" onClick={toggle} aria-expanded={open} className="w-full flex items-center gap-3 px-4 sm:px-5 py-3.5 text-left" data-testid={`settings-toggle-${id}`}>
        <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md ${open ? "bg-[#0b1f3a] text-white" : "bg-slate-100 text-[#0b1f3a]"}`}><Icon className="h-4.5 w-4.5" /></span>
        <span className="flex-1 min-w-0">
          <span className="block text-sm font-semibold text-slate-900">{title}</span>
          {description && <span className="block text-xs text-slate-500 truncate">{description}</span>}
        </span>
        {badge}
        <ChevronDown className={`h-4 w-4 shrink-0 text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="border-t border-slate-200 px-4 sm:px-5 py-5" data-testid={`settings-body-${id}`}>{children}</div>}
    </section>
  );
}
